import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { caseResults, caseSteps } from '../../data/content';
export function CaseScenario() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-114" data-mp="31kkqzud23zhw">
      <div className="mx-auto max-w-3xl" data-id="element-115" data-mp="31i6x3ou44tbx">
        <p className="text-center font-display text-sm font-extrabold text-brand" data-id="element-116" data-mp="36icfeeeht3hc">See how the system works in a realistic clinical scenario</p>
        <h2 className="mt-3 text-center font-display text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-117" data-mp="2si1s1lce670x">
          From a Functional Observation to an Organized Intervention Plan
        </h2>

        <div className="mt-8 rounded-2xl bg-navy p-5 text-white" data-id="element-118" data-mp="2in9tofazjg53">
          <p className="text-[17px] leading-relaxed" data-id="element-119" data-mp="2nl1i2zcf8k4j">
            Imagine you're working with a school-aged child who has difficulty completing a multi-step dressing routine. The child can perform several individual movements but has difficulty organizing and sequencing the complete task.
          </p>
          <p className="mt-3 font-semibold text-accent" data-id="element-120" data-mp="36agl7fdpqcgi">Instead of immediately choosing activities, you apply the pathway.</p>
        </div>

        <ol className="mt-8 space-y-5" data-id="element-121" data-mp="31au7l4tz2u76">
          {caseSteps.map((s, i) => <li key={s.title} className="flex gap-4" data-id="element-122" data-mp="3g3nql08gdsgl" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand font-display font-extrabold text-white" data-id="element-123" data-mp="3b285j869zly7">{i + 1}</span>
              <div data-id="element-124" data-mp="2neqj7s5s5g2m">
                <h3 className="font-display text-lg font-extrabold text-navy" data-id="element-125" data-mp="2ie2k0j7edsxb">{s.title}</h3>
                <p className="mt-1 text-[15px] text-navy/75" data-id="element-126" data-mp="2wdlngyp9kg3a">{s.body}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl border-2 border-brand bg-brand-light p-6" data-id="element-127" data-mp="2saxg6vg77h8f">
          <p className="font-display text-2xl font-extrabold text-navy" data-id="element-128" data-mp="bml9x09z2cqc">The Result?</p>
          <p className="mt-1 text-navy/75" data-id="element-129" data-mp="7m1afq1xex11">A connected planning document containing:</p>
          <ol className="mt-4 space-y-2" data-id="element-130" data-mp="30g8a75h7b4s1">
            {caseResults.map((r, i) => <li key={r} className="flex items-center gap-3 rounded-xl bg-white p-3 font-semibold text-navy" data-id="element-131" data-mp="30im255gl40vd" data-mpi={i}>
                <FileTextIcon className="h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-132" data-mp="3aefn9d8dd2or" />
                {i + 1}. {r}
              </li>)}
          </ol>
          <p className="mt-5 text-sm text-navy/70" data-id="element-133" data-mp="3ef7xo9sz9dmm">
            No guaranteed clinical outcome. No one-size-fits-all intervention prescription. Just a structured professional workflow that supports clearer organization and documentation.
          </p>
        </div>

        <SectionCTA label="Build My First Connected Case Plan" data-id="element-134" data-mp="2qpdny13yg56l" />
      </div>
    </section>;
}